const { filterType } = require('./filterparamtype');

function urlMatcherConfig($urlMatcherFactoryProvider) {
    $urlMatcherFactoryProvider.caseInsensitive(true);
    $urlMatcherFactoryProvider.strictMode(false);

    $urlMatcherFactoryProvider.type('filter', filterType);
}

module.exports = { urlMatcherConfig };



// WEBPACK FOOTER //
// ./src/configuration/urlmatcher.js